

import { NotificationService } from "@/services/NotificationService";
import { UserService } from "@/services/UserService";
import { defineComponent } from "vue";
import { container } from "tsyringe";

const jQuery = require('jquery');


export default defineComponent({
  
  data() {
    return {
      kod: "",
      userId: null,
      remember: null,
      errorMessage: null,
    };
  },

  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.userId = urlParams.get('id');
    this.remember = urlParams.get('remember');

    if (this.$route.query.logout) {
      let userService = container.resolve(UserService);
      userService.logout();
    }
  },

  mounted() {

    jQuery("#kod").kendoTooltip();

    // Web OTP API – obejdeme TS typovou chybu
    if ("OTPCredential" in window) {
      const abortController = new AbortController();


      (navigator.credentials as any).get({
        otp: {transport: ["sms"]},
        signal: abortController.signal,
      })
          .then((otp: any) => {
            console.log("Získaný OTP kód: ", otp.code);  // Ladicí výstup
            this.kod = otp.code;
          })
          .catch((err: any) => {
            console.warn("Chyba při získávání OTP kódu:", err);
          });

      // Optional: automatické zrušení po 60 vteřinách
      setTimeout(() => abortController.abort(), 60000);
    }

  },

  methods: {
    async verification() {


      let userService = container.resolve(UserService);
      let result = await userService.verify(this.userId, this.kod,this.remember);
      if (!result.result) {
        this.errorMessage = "Chyba: ověřovací kód není platný.";
        return;
      }

      this.$router.push("/");

    }

  }



});
